<template>
    <a class="card event-card" :class="event.eventClass" :href="event.uri">
        <div class="event-card__image">
            <div class="event-card__category" v-if="event.eventType">
                {{ event.eventType[0].title }}
            </div>
            <img :src="event.summaryImage[0].url" :alt="event.title">
        </div>
        <div class="event-card__details">
            <h2>{{ event.title }} </h2>
            <p v-if="event.summaryText">{{ event.summaryText }}</p>
            <p>
                <span class="event-location">{{ event.eventLocation }}</span><br>
                <span class="event-date">
                  {{ asDate( event.startTime ) }}
                  <span v-if="showEndTime"> - {{ asDate( event.endTime ) }}</span>
                </span><br>
                <span class="event-time" v-if="event.showEventTimes">
                  {{ asTime( event.startTime ) }}
                  <span v-if="event.endTime"> - {{ asTime( event.endTime ) }}</span>
                </span>
            </p>
        </div>
        <div class="event-card__subpages" v-if="event.children && event.eventType[0].title == 'Conference' &! hideLinks" >
            <div class="event-card__subpage" v-for="subPage in event.children" :key="subPage.title">
                <a :href="subPage.uri">{{ subPage.title }}</a>
            </div>
         </div>
        <span class="read-more">Read more &nbsp;&nbsp; ⟶</span>
    </a>
</template>

<script>
import { defineComponent, computed } from 'vue';
import { DateTime } from 'luxon';

export default defineComponent({
    props: {
        event: {
            required: true,
            type: Object,
        },
        hideLinks: {
            type: Boolean,
        },
    },
    components: {
        DateTime,
    },
    setup(props) {
        const asDate = (value) => {
            return DateTime.fromISO(value).toLocaleString(DateTime.DATE_FULL);
        };

        const asTime = (value) => {
            return DateTime.fromISO(value).toLocaleString(DateTime.TIME_SIMPLE);
        };

        const showEndTime = computed(() => {
            if (!props.event.endTime) {
                return false;
            }
            if (
                props.event.startTime.substr(0, 10) ===
                props.event.endTime.substr(0, 10)
            ) {
                return false;
            }
            return true;
        });

        return {
            asDate,
            asTime,
            showEndTime,
        };
    },
});
</script>
